function SuspenseContent(){
    return(
        <div className="flex justify-center items-center w-full h-screen">
        <span className="loading loading-spinner loading-lg text-primary"></span>
      </div>
    )
}

export default SuspenseContent